/**
 * LOG-HUMAN-VIEW — which Team Log posts are machine bookkeeping a human never
 * acts on. The Log hides them from humans by default (see TeamLogStream);
 * agents reading through MCP get_messages are unaffected.
 */
import type { TeamLogMessage } from "../types";

export const SYSTEM_POST_TAGS: readonly string[] = [
  "tokens",
  "scheduler-log",
  "review-verdict-recorded",
  "workspace-md-update",
  "review-status-post-failed",
  "directive-queued",
  "daemon-restart-recovery",
];

/** relay-daemon's own backlog-resolved closes are bookkeeping; other authors' are not. */
export const SYSTEM_POST_DAEMON_AUTHOR = "relay-daemon";
export const SYSTEM_POST_DAEMON_TAG = "backlog-resolved";

export function isSystemPost(msg: Pick<TeamLogMessage, "author" | "tags">): boolean {
  const tags = msg.tags ?? [];
  // Directives show what agents were asked to do — always visible.
  if (tags.includes("directive")) return false;
  if (tags.some(t => SYSTEM_POST_TAGS.includes(t))) return true;
  return msg.author === SYSTEM_POST_DAEMON_AUTHOR && tags.includes(SYSTEM_POST_DAEMON_TAG);
}

export const SHOW_SYSTEM_POSTS_STORAGE_KEY = "relay.teamLog.showSystemPosts";

/** Remembered choice; any storage failure falls back to hidden (false). */
export function readShowSystemPosts(): boolean {
  try {
    return window.localStorage.getItem(SHOW_SYSTEM_POSTS_STORAGE_KEY) === "1";
  } catch {
    return false;
  }
}

export function writeShowSystemPosts(show: boolean): void {
  try {
    window.localStorage.setItem(SHOW_SYSTEM_POSTS_STORAGE_KEY, show ? "1" : "0");
  } catch {
    // storage unavailable — the choice just isn't remembered
  }
}
